import SuccessIcon from './component.jsx'
export default SuccessIcon
